import { withStyles, withTheme } from '@material-ui/core';
import ClosingSoonBadge from '../../../Common/ClosingSoonBadge';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../appConfigContext';
import UnattendedDelivery from '../../../../Common/UnattendedDelivery';

const styles = () => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  unattendedIcon : {
    marginLeft:"10px"
  }
});
@inject('DispatchStore')
@observer
class StopCardTitle extends React.PureComponent {
  render() {
    const {
      pickupIds,
      pickupId,
      title,
      classes,
      unattendedStop,
      DispatchStore: { pickupIdToClosingTimeMapping },
      configJSON: { closingSoonWarningTimeLimit, closingSoonAlertTimeLimit }
    } = this.props;
    const closingSoonLimitConfig = {
      closingSoonWarningTimeLimit,
      closingSoonAlertTimeLimit
    }
    return (
      <div className={classes.titleContainer}>
        {title}
        {Boolean(pickupId) && (
          <ClosingSoonBadge
            timeToCloseInMins={pickupIdToClosingTimeMapping[pickupIds.join(', ').toUpperCase()]}
            closingSoonLimitConfig={closingSoonLimitConfig}
          />
        )}
        {unattendedStop && (
          <span className={classes.unattendedIcon}>
            <UnattendedDelivery color={this.props.theme.iconColor} />
          </span>
        )}
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles), withTheme())(StopCardTitle);
